import { Button, Menu, MenuItem } from '@mui/material';
import { KeyboardArrowDownOutlined } from '@mui/icons-material';
import { ReactElement, ReactNode, useState } from 'react';
import { tokens } from '@synergy/theme-palo';

export interface PaloActionMenuItem {
    label: ReactNode;
    onClick: () => void;
    disabled?: boolean;
}

export interface PaloActionMenuProps {
    label: ReactNode;
    items: PaloActionMenuItem[];
    icon?: ReactNode;
    /** Filled accent button instead of the outlined default. */
    primary?: boolean;
    disabled?: boolean;
}

/**
 * Dropdown button for PALO headers. The legacy PoolMenu is styled for the
 * turquoise toolbar (light text), so it disappears on the PALO canvas — this
 * renders the same kind of menu with header button styling instead.
 */
export const PaloActionMenu = ({ label, items, icon, primary, disabled }: PaloActionMenuProps): ReactElement => {
    const [anchor, setAnchor] = useState<HTMLElement | null>(null);

    const handleSelect = (item: PaloActionMenuItem) => () => {
        setAnchor(null);
        item.onClick();
    };

    return (
        <>
            <Button
                variant={primary ? 'contained' : 'outlined'}
                color={primary ? 'primary' : 'inherit'}
                size="small"
                sx={primary ? undefined : { color: tokens.color.ink2 }}
                startIcon={icon}
                endIcon={<KeyboardArrowDownOutlined />}
                disabled={disabled}
                onClick={event => setAnchor(event.currentTarget)}
            >
                {label}
            </Button>
            <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
                {items.map((item, index) => (
                    <MenuItem key={index} onClick={handleSelect(item)} disabled={item.disabled}>
                        {item.label}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};
